module.exports = __webpack_public_path__ + "static/media/PACIMob.2129b3bb.svg";